// Central icon set (react-icons) — no emojis anywhere in the UI.
import {
  FiPhone,
  FiMapPin,
  FiClock,
  FiMenu,
  FiX,
  FiChevronLeft,
  FiChevronRight,
  FiArrowRight,
  FiGlobe,
  FiHeart,
  FiEdit2,
  FiZoomIn,
} from "react-icons/fi";
import { FaWhatsapp, FaGem, FaBalanceScale } from "react-icons/fa";
import {
  GiCutDiamond,
  GiRoundStar,
  GiNecklace,
  GiTiara,
  GiEarrings,
  GiDiamondRing,
  GiLinkedRings,
  GiGemNecklace,
  GiGemChain,
  GiWatch,
  GiElephant,
  GiLotus,
  GiGems,
} from "react-icons/gi";

export {
  FiPhone,
  FiMapPin,
  FiClock,
  FiMenu,
  FiX,
  FiChevronLeft,
  FiChevronRight,
  FiArrowRight,
  FiGlobe,
  FiHeart,
  FiEdit2,
  FiZoomIn,
  FaWhatsapp,
  FaGem,
  FaBalanceScale,
  GiCutDiamond,
  GiRoundStar,
  GiNecklace,
  GiTiara,
  GiEarrings,
  GiDiamondRing,
  GiLinkedRings,
  GiGemNecklace,
  GiGemChain,
  GiWatch,
  GiElephant,
  GiLotus,
  GiGems,
};

// Category id -> icon component
export const categoryIcons = {
  necklaces: GiNecklace,
  bridal: GiTiara,
  earrings: GiEarrings,
  rings: GiDiamondRing,
  bangles: GiLinkedRings,
  chains: GiGemNecklace,
  anklets: GiGemChain,
  watches: GiWatch,
};
